import { BASE_STORE_FINDER_URL } from '@/lib/const';

// Maps Storefront URL language slugs to corresponding Store Finder language codes
const languageCodeMap: Record<string, string> = {
  de: 'de',
  en: 'en',
  es: 'es',
  fr: 'fr',
  it: 'it',
  ja: 'ja',
  ko: 'ko',
  pt: 'pt',
  ru: 'ru',
  zh: 'zh_hans',
  zht: 'zh_hant',
};

/**
 * Generate the store URL for the Store Finder website
 * @param url - Base URL of the Store Finder website
 * @param localeSlug - The language slug from Storefront URL
 * @param countryCode
 * @example
 * getStoreUrl("https://store.example.com/", "zh", "US");
 * // Returns: "https://store.example.com/zh_hans?country=US"
 */
export const getStoreUrl = (
  url?: string | null,
  localeSlug?: string | null,
  countryCode?: string | null,
) => {
  const baseUrl = url ?? BASE_STORE_FINDER_URL;
  const languageCode = languageCodeMap[localeSlug ?? ''] ?? '';
  const countryQueryParam = countryCode ? `?country=${countryCode}` : '';

  return `${baseUrl.replace(/\/?$/, '/')}${languageCode}${countryQueryParam}`;
};
